// extracted by mini-css-extract-plugin
export default {"host":"style_host__KkTQ7","hint":"style_hint__9lqdk","code":"style_code__oHcLj","apps":"style_apps__lm6gz","qr":"style_qr__uyxIT","submit":"style_submit__O0L9e"};